// extracted by mini-css-extract-plugin
module.exports =  {"root":"d8SvuuSjkwYtwI_oUFxd","container":"x2bqpE3VwEqY4PvJR1v7"};